// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__1+iV2","socials":"Footer_socials__ArJGy"};